import { AxiosResponse } from 'axios'
import loginData from '../utilities/loginData'
import apiClient from './common/common'
import { CompleteDealCheckRequest } from './common/requests'
import { CompleteDealCheckResponse } from './common/responses'
import { Status } from './common/statuses'

/**
 * PanaceaPay決済完了チェックAPI
 * @param request
 * @param callback
 */
export const completeDealPanaceaPayCheckAPI = async (request: CompleteDealCheckRequest, callback: (isPayed: boolean) => void) => {
  await apiClient.get('/completeDeal/check/panaceaPay', { params: request }).then((response: AxiosResponse<CompleteDealCheckResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const result = status === Status.Success
    if (result) {
      loginData.setContractStatus(response.data.contractStatus)
      loginData.setRegistrationStatus(response.data.registrationStatus)
      loginData.setUserType(response.data.userType)
    }
    callback(!!response?.data?.isPayed)
  })
}

/**
 * CREDIX決済完了チェックAPI
 * @param request
 * @param callback
 */
export const completeDealCredixCheckAPI = async (request: CompleteDealCheckRequest, callback: (isPayed: boolean) => void) => {
  await apiClient.get('/completeDeal/check/credix', { params: request }).then((response: AxiosResponse<CompleteDealCheckResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const result = status === Status.Success
    if (result) {
      loginData.setContractStatus(response.data.contractStatus)
      loginData.setRegistrationStatus(response.data.registrationStatus)
      loginData.setUserType(response.data.userType)
    }
    callback(!!response?.data?.isPayed)
  })
}
